import { render } from "./ent_notes.vue?vue&type=template&id=6248f880&scoped=true"
import script from "./ent_notes.vue?vue&type=script&lang=js"
export * from "./ent_notes.vue?vue&type=script&lang=js"

import "./ent_notes.vue?vue&type=style&index=0&id=6248f880&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6248f880"]])

export default __exports__